"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.PassportReader = void 0;
var tulons_1 = require("tulons");
var PassportReader = (function () {
    function PassportReader(url, network) {
        if (url === void 0) { url = "https://ceramic.passport-iam.gitcoin.co"; }
        if (network === void 0) { network = "1"; }
        this._tulons = new tulons_1.Tulons(url, network);
        this._ceramic_gitcoin_passport_stream_id =
            "kjzl6cwe1jw148h1e14jb5fkf55xmqhmyorp29r9cq356c7ou74ulowf8czjlzs";
    }
    PassportReader.prototype.getGenesis = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, this._tulons.getGenesis(address)];
                    case 1:
                        genesis = _b.sent();
                        return [3, 3];
                    case 2:
                        _a = _b.sent();
                        genesis = false;
                        return [3, 3];
                    case 3: return [2, genesis];
                }
            });
        });
    };
    PassportReader.prototype.getPassport = function (address, streams) {
        return __awaiter(this, void 0, void 0, function () {
            var passport;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPassportStream(address, streams)];
                    case 1:
                        passport = _a.sent();
                        if (!passport) return [3, 3];
                        return [4, this._tulons.getHydrated(passport)];
                    case 2: return [2, (_a.sent())];
                    case 3: return [2, passport];
                }
            });
        });
    };
    PassportReader.prototype.getPassportStream = function (address, streams) {
        return __awaiter(this, void 0, void 0, function () {
            var passport, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!(streams && streams[this._ceramic_gitcoin_passport_stream_id])) return [3, 1];
                        _a = streams;
                        return [3, 3];
                    case 1: return [4, this._tulons.getGenesis(address, [
                            this._ceramic_gitcoin_passport_stream_id,
                        ])];
                    case 2:
                        _a = (_c.sent()).streams;
                        _c.label = 3;
                    case 3:
                        streams = _a;
                        return [4, this._tulons.getStream(streams[this._ceramic_gitcoin_passport_stream_id])];
                    case 4:
                        passport = (_c.sent());
                        return [3, 6];
                    case 5:
                        _b = _c.sent();
                        passport = false;
                        return [3, 6];
                    case 6: return [2, passport];
                }
            });
        });
    };
    return PassportReader;
}());
exports.PassportReader = PassportReader;
